import { Box, Container } from "@mui/material";
import React from "react";
import Accessories from "../assets/images/categries/acessories.jpg";
import Clothing from "../assets/images/categries/clothing.webp";
import Footerwear from "../assets/images/categries/footerwear.jpg";
import Handbag from "../assets/images/categries/handbag.jpg";
import Category from "./Category";
import Masonry from "react-masonry-css";
export default function Categories() {
  const categories = [
    {
      title: "accessories",
      img: Accessories,
      link: "/collections",
    },
    { title: "clothing", img: Clothing, link: "/collections" },
    { title: "footwear", img: Footerwear, link: "/collections" },
    { title: "handbag", img: Handbag, link: "/collections" },
  ];
  return (
    <Container sx={{ my: { lg: 8, md: 6, sm: 4, xs: 2 } }}>
      <Masonry
        breakpointCols={{
          default: 2,
          600: 1,
          900: 2,
          1200: 2,
        }}
        className="my-masonry-grid"
        columnClassName="my-masonry-grid_column"
      >
        {categories.map((cat) => (
          <Category
            key={cat.title}
            title={cat.title}
            img={cat.img}
            link={cat.link}
          />
        ))}
      </Masonry>
    </Container>
  );
}
